<template>
  <v-dialog v-model="dialog">
    <template v-slot:activator="{ on, attrs }">
      <a v-bind="attrs" v-on="on" @click="SearchLog()" v-if="!ButtonStyle"
        >查詢</a
      >
      <v-btn
        color="primary"
        dark
        block
        v-bind="attrs"
        v-on="on"
        v-if="ButtonStyle"
        @click="SearchLog()"
      >
        查詢簽核歷程
      </v-btn>
    </template>

    <v-card>
      <v-toolbar dark color="#0277BD" elevation="0">
        <v-toolbar-title>簽核歷程</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="details"
        :items-per-page="15"
        class="elevation-1"
      >
        <template v-slot:no-data>
          <div>尚無簽核紀錄</div>
        </template>
      </v-data-table>
    </v-card>
  </v-dialog>
</template>
<script>
//API
import { apiGetLog } from "../utils/request/periodicReview";
//取得狀態名稱
import { GetLogName } from "../utils/signState";

export default {
  props: {
    //查詢簽核歷程用
    SourceGUID: {
      type: String,
      default: null,
    },
    //查詢按鈕樣式
    ButtonStyle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: false,
      headers: [
        {
          align: "center",
          value: "name",
        },
        { text: "簽核時間", value: "signTime", width: "25%" },
        {
          text: "簽核人員",
          value: "userName",
          width: "25%",
          sortable: false,
        },
        {
          text: "簽核結果",
          value: "signResult",
          width: "15%",
          sortable: false,
        },
        {
          text: "簽核意見",
          value: "signComment",
          width: "35%",
          sortable: false,
        },
      ],
      details: [],
    };
  },
  methods: {
    async SearchLog() {
      let result = await apiGetLog(this.SourceGUID);
      this.details = result.data;
      this.details.forEach((d) => {
        if (d.signTime) d.signTime = d.signTime.replace("T", " ");
      });
    },
  },
  watch: {
    details: function () {
      this.details.forEach((element, index) => {
        this.details[index].signResult = GetLogName(element.signResult);
      });
    },
  },
};
</script>
